import { notification } from "antd";

// Reads the message from: thrown axios error, returned response, or {status, message, data} envelope
export const getErrorMessage = (
  error: any,
  fallback = "Something went wrong"
): string => {
  const data = error?.response?.data ?? error?.data;
  if (typeof data === "string" && data.trim()) return data;
  return (
    data?.message ||
    data?.error ||
    data?.errors?.[0]?.message ||
    error?.message ||
    fallback
  );
};

export const showApiError = (
  error: any,
  title = "Error",
  fallback?: string
) => {
  notification.error({
    message: title,
    description: getErrorMessage(error, fallback),
    duration: 5,
  });
};

// true only when HTTP 200 AND the backend envelope is not status -1
export const isApiSuccess = (response: any): boolean =>
  response?.status === 200 && response?.data?.status !== -1;